export default "__VITE_ASSET__R53Tw35___"